// packages/shared/api-client/endpoints/userNotes.js
// User notes API endpoints

import { baseApi } from "../baseApi";

/**
 * User Notes API endpoints
 * Provides confidential note management for member welfare tracking
 * Requires MANAGE_USER_NOTES permission
 */
const userNotesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get all notes for a specific user
    getUserNotes: builder.query({
      query: (userId) => `/api/users/${userId}/notes`,
      providesTags: (result, error, userId) => [
        { type: "UserNote", id: userId },
      ],
    }),

    // Create a new note for a user
    createUserNote: builder.mutation({
      query: ({ userId, content, category }) => ({
        url: `/api/users/${userId}/notes`,
        method: "POST",
        body: { content, category },
      }),
      invalidatesTags: (result, error, { userId }) => [
        { type: "UserNote", id: userId },
      ],
    }),

    // Update an existing note
    updateUserNote: builder.mutation({
      query: ({ noteId, content, category }) => ({
        url: `/api/user-notes/${noteId}`,
        method: "PUT",
        body: { content, category },
      }),
      invalidatesTags: (result, error, { noteId }) => [
        { type: "UserNote", id: noteId },
      ],
    }),

    // Delete a note
    deleteUserNote: builder.mutation({
      query: (noteId) => ({
        url: `/api/user-notes/${noteId}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, noteId) => [
        { type: "UserNote", id: noteId },
      ],
    }),
  }),
});

// Export hooks for usage in components
export const useGetUserNotesQuery = userNotesApi.useGetUserNotesQuery;
export const useLazyGetUserNotesQuery = userNotesApi.useLazyGetUserNotesQuery;
export const useCreateUserNoteMutation = userNotesApi.useCreateUserNoteMutation;
export const useUpdateUserNoteMutation = userNotesApi.useUpdateUserNoteMutation;
export const useDeleteUserNoteMutation = userNotesApi.useDeleteUserNoteMutation;
